<div class="my-2">
  <form [formGroup]="formData">
    <label
      *ngIf="
        section.label !== 'Allergies' &&
        (group.name === 'other details' ||
          group.name === 'diet allergies' ||
          group.name === 'relative' ||
          group.name === 'likes dislikes')
      "
      >{{ question.label }}</label
    >
    <textarea
      formControlName="field"
      rows="5"
      class="form-control ng-pristine ng-invalid ng-touched"
      [ngClass]="{ 'is-invalid': form.field.errors }"></textarea>
    <div
      class="mt-2"
      *ngIf="form.field.errors"
      style="font-size: 80%; color: rgb(244 106 106)">
      <span *ngIf="form.field.errors.required"
        >Please provide a valid response.</span
      >
      <span *ngIf="form.field.errors.maxlength"
        >This value is too long. It should have
        {{ questionParams.maxLength }} characters or fewer.</span
      >
    </div>
  </form>
</div>
